import { Theme } from "@emotion/react";
import { Container, ContainerProps, Paper, PaperProps, SxProps } from "@mui/material";
import { PropsWithChildren } from "react";

interface Props extends PropsWithChildren {
    containerProps?: ContainerProps
    paperProps?: PaperProps
    sx?: SxProps<Theme> 
}
export function Content(props: Props){
    const {
        children,

        sx,
        containerProps,
        paperProps
    } = props
    return (
        <Container {...(containerProps || {})}>
            <Paper elevation={0} sx={{p: '10px', ...(sx || {})}} {...(paperProps || {})}>
                {children}
            </Paper>
        </Container>
    )
}